import { DELETED_ACCOUNT_LABEL, isDeletedAccountUsername } from './user';

function displayUserName(
  user: { name: string; email: string; username?: string | null },
  isElseEmail?: boolean,
): string {
  if (isDeletedAccountUsername(user.username)) return DELETED_ACCOUNT_LABEL;

  return (user.name || '') || (isElseEmail ? user.email : '');
}

export default displayUserName;
